export default __webpack_public_path__ + "static/instantChatBg1-ab5b0e52afa8b05c30050401f8397d57.png";